<template>
  <div class="container">
    <div
      class="row"
      v-if="participante.atualizarCadastro || participante.bloquearNavegacao"
    >
      <div class="col-12">
        <div
          class="alert alert-danger"
          role="alert"
          v-if="participante.bloquearNavegacao"
        >
          <h4 class="alert-heading">Atenção</h4>
          <p>{{ mensagemValidacao["aviso"] }}</p>
          <ul v-for="item in participante.itensAtualizacao" :key="item">
            <li>
              {{ mensagemValidacao[item] }}
            </li>
          </ul>
          <hr />
          <p class="mb-0">Você terá acesso aos formulários após atualização.</p>
        </div>
        <div
          class="alert alert-info"
          role="alert"
          v-if="participante.atualizarCadastro"
        >
          <h4 class="alert-heading">Aviso</h4>
          <p>
            Por favor revise suas informações de contato, número de celular e
            caso possua seu e-mail também.<br />
            Isso facilitará a abordagem do time de saúde.
          </p>
        </div>
      </div>
    </div>

    <form class="form-horizontal" role="form">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div class="form-group">
            <label for="cpf" class="control-label">CPF<i>*</i></label>

            <input
              type="text"
              id="cpf"
              v-model="pessoa.cpf"
              @blur="handleBlurCpf"
              placeholder="CPF"
              class="form-control"
              autofocus
              required
              v-mask="'###.###.###-##'"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div :class="`form-group ${validacao.nome}`">
            <label for="nome" class="col-sm-5 control-label"
              >Nome<i>*</i></label
            >
            <input
              type="text"
              id="nome"
              @blur="handleChange"
              v-model="pessoa.nome"
              placeholder="Nome Completo"
              class="form-control"
              required
              autofocus
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div :class="`form-group ${validacao.nomeSocial}`">
            <label for="nomeSocial" class="col-sm-5 control-label"
              >Nome Social</label
            >

            <input
              type="text"
              id="nomeSocial"
              @blur="handleChange"
              v-model="pessoa.nomeSocial"
              placeholder="Nome Social"
              class="form-control"
              autofocus
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div :class="`form-group ${validacao.dataNascimento}`">
            <label for="dataNascimento" class="control-label"
              >Data de Nascimento<i>*</i></label
            >

            <input
              type="text"
              id="dataNascimento"
              placeholder="DD/MM/AAAA"
              required
              v-model="pessoa.dataNascimentoFormatada"
              v-mask="'##/##/####'"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div class="form-group">
            <label for="email" class="control-label">Email</label>

            <input
              type="email"
              id="email"
              placeholder="E-mail"
              class="form-control"
              name="email"
              v-model="pessoa.email"
            />
            <p class="text-danger" v-if="deveAtualizarEmail">
              Informe um e-mail.
            </p>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div class="form-group">
            <label for="numeroCelular" class="control-label"
              >Número Celular<i>*</i></label
            >

            <input
              type="phoneNumber"
              id="numeroCelular"
              placeholder="Número celular"
              v-mask="'(##) #####-####'"
              v-model="pessoa.numeroCelular"
              class="form-control"
            />
            <p class="text-danger" v-if="deveAtualizarCelular">
              Informe um número de celular.
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="form-group">
            <label class="control-label">Genero</label>
            <div class="col">
              <div class="row">
                <div class="col-5">
                  <label class="radio-inline" for="generoNaoInformado">
                    <input
                      v-model="pessoa.genero"
                      name="genero"
                      type="radio"
                      id="generoNaoInformado"
                      value="3"
                    />&nbsp;Não Informado
                  </label>
                </div>
                <div class="col">
                  <label class="radio-inline">
                    <input
                      name="genero"
                      v-model="pessoa.genero"
                      type="radio"
                      id="generoMasculino"
                      value="1"
                    />&nbsp;Masculino
                  </label>
                </div>
                <div class="col">
                  <label class="radio-inline">
                    <input
                      type="radio"
                      v-model="pessoa.genero"
                      name="genero"
                      id="generoFeminino"
                      value="2"
                    />&nbsp;Feminino
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
        <div class="form-group">
          <label class="control-label">Estado Civil</label>
        
            <select
              id="estadoCivil"
              name="estadoCivil"
              v-model="pessoa.estadoCivil"
              class="form-control"
            >
              <option
                :value="estadoCivil.id"
                v-for="(estadoCivil, index) in estadosCivil"
                :key="index"
              >
                {{ estadoCivil.nome }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- /.form-group -->
      <div class="row">
        <div class="col">
          <span class="help-block"><i>*</i>&nbsp;Campos obrigatórios</span>
        </div>
      </div>
      <hr />
      <div class="row">
       <div class="col">
        <button
          v-if="!cadastroExistente"
          type="button"
          @click="handleSalvar"
          class="btn btn-success"
        >
          Criar conta
        </button>
        <button
          v-if="cadastroExistente"
          type="button"
          @click="handleAtualizarInformacoes"
          class="btn btn-success"
        >
          Atualizar informações
        </button>
       </div>
      </div>
    </form>


  </div>
  <!-- ./container -->
</template>

<script>
import pessoaService from "../services/PessoaService";
import loginService from "../services/LoginService";
import notificacaoService from "../services/Notificacao.service";
import storageService from "../services/storageService";
import { USER_CONFIG } from "../config/UserConfig";
import { GENERO } from "../config/Genero";

const valorInicialPessoa = {
  nome: "",
  cpf: "",
  pessoaId: "",
  dataNascimento: "",
  email: "",
  numeroCelular: "",
  estadoCivil: 0,
  genero: 3,
  codigoCliente: "",
};
export default {
  name: "CadastroPessoa",
  computed: {
    estadosCivil() {
      const { genero } = this.pessoa;

      if (genero == GENERO.OUTRO) return this.listaEstadoCivil.outros;
      if (genero == GENERO.MASCULINO) return this.listaEstadoCivil.masculino;
      if (genero == GENERO.FEMININO) return this.listaEstadoCivil.feminino;
    },
    participante() {
      const { participante } = this.$store.state;
      return participante;
    },
    deveAtualizarCelular() {
      return (
        this.participante &&
        this.participante.itensAtualizacao &&
        this.participante.itensAtualizacao.includes("numero_celular")
      );
    },
    deveAtualizarEmail() {
      return (
        this.participante &&
        this.participante.itensAtualizacao &&
        this.participante.itensAtualizacao.includes("email")
      );
    },
  },

  methods: {
    async handleBlurCpf(e) {
      const cpf = this.pessoa.cpf;

      if (!cpf.length) return;
      if (this.$route.name == "PrimeiroAcesso") {
        //consultar cpf

        const codigoCliente = this.pessoa.codigoCliente;
        const pessoaExiste = await pessoaService.consultarPessoaExiste(
          cpf,
          codigoCliente
        );

        if (pessoaExiste) {
          notificacaoService.erro(`CPF: ${this.pessoa.cpf} está cadastrado!`);
          return;
        }
      }

      this.handleChange(e);
    },
    handleChange(e) {
      const erros = [];
      const { id: nomeCampo = "", value } = e.target;
      if (nomeCampo) {
        if (nomeCampo == "nome") {
          this.validacao[`${nomeCampo}`] = !value ? "hasError" : "hasSuccess";
        } else if (nomeCampo == "dataNascimento") {
          this.validacao[`${nomeCampo}`] = !value ? "hasError" : "hasSuccess";
        }
      }
    },
    async handleSalvar() {
      const { pessoa } = this;
      const novaPessoa = { ...pessoa };
      const { clienteFormulario } = this.$store.state;
      novaPessoa.codigoCliente = clienteFormulario.codigoCliente;
      if (novaPessoa.dataNascimentoFormatada) {
        const [dia, mes, ano] = novaPessoa.dataNascimentoFormatada.split("/");
        novaPessoa.dataNascimento = `${ano}-${mes}-${dia}`;
      }

      try {
        this.$loading(true);
        const result = await pessoaService.cadastrarPessoa(novaPessoa);
        const { sucesso, erros, retorno } = result;
        if (sucesso) {
          const { nome, pessoaId } = retorno;
          //this.$store.dispatch("adicionarPessoa", { nome, pessoaId }

          //Apos sucesso no cadastro efetuar o login
          const {
            retorno: retornoLogin,
            sucesso: sucessoLogin,
            erros: errosLogin,
          } = await loginService.efetuarLogin(novaPessoa);

          if (sucessoLogin) {
            //limpar dados do localstoratge
            storageService.removeItem(USER_CONFIG.loggedUser);
            storageService.removeItem(USER_CONFIG.token);

            this.$store.dispatch("adicionarPessoa", retornoLogin);
            this.$store.dispatch("adicionarTokenSessao", retornoLogin);

            notificacaoService
              .sucesso("Cadastro realizado com sucesso")
              .then(() => {
                this.$loading(false);

                this.$router.push({
                  name: "RedirecionarPage",
                  params: { apelidoCliente: clienteFormulario.apelidoUnico },
                });
              });
            //redirecionar para uma tela que faça as verificações se vai responder formulario ou ver a listagem
            //add a pessoa no vuex
          } else {
            notificacaoService.erro("Houve erro ao processar solicitação");
            this.$loading(false);
          }
        } else {
          notificacaoService.erro(
            erros,
            erros.length > 1 ? "Dados inválidos" : "Dado inválido",
            true
          );
          this.$loading(false);
        }
      } catch (error) {
        notificacaoService.erro("Houve erro ao processar solicitação");
        this.$loading(false);
      }
    },

    async handleAtualizarInformacoes() {
      const { pessoa, participante } = this;
      const { clienteFormulario } = this.$store.state;
      pessoa.codigoCliente = clienteFormulario.codigoCliente;
      const participanteAtualizar = {
        ...participante,
        bloquearNavegacao: false,
      };
      const _participante = { ...participante };

      try {
        const result = await pessoaService.atualizarPessoa(pessoa);
        const { sucesso, erros, retorno } = result;
        console.log("participante==>", participante);
        if (sucesso) {
          notificacaoService
            .sucesso("Cadastro atualizado com sucesso")
            .then((ok) => {
              this.$store.dispatch("adicionarPessoa", participanteAtualizar);
              if (_participante.bloquearNavegacao || this.deveAtualizarCelular)
                this.$router.push({ name: "ListagemFormulario" });
            });
          //redirecionar para uma tela que faça as verificações se vai responder formulario ou ver a listagem
          //add a pessoa no vuex
        } else {
          notificacaoService.erro(
            erros,
            erros.length > 1 ? "Dados inválidos" : "Dado inválido",
            true
          );
        }
      } catch (error) {
        notificacaoService.erro("Houve erro ao processar solicitação");
      }
    },
    validarDadosCadastro() {},
  },
  mounted() {
    let { clienteFormulario } = this.$store.state;

    if (clienteFormulario && !clienteFormulario.codigoCliente) {
      clienteFormulario = storageService.getJsonItem(
        USER_CONFIG.clienteFormulario
      );
    }

    this.pessoa.codigoCliente =
      this.codigoCliente || clienteFormulario.codigoCliente;

    if (this.participante && this.participante.pessoaId) {
      pessoaService.obterDadosPessoaLogada().then((pessoaResult) => {
        this.pessoa = { ...pessoaResult };
        this.cadastroExistente = true;
        console.log("this.pessoa", this.pessoa);
      });
    }
  },
  data() {
    return {
      cadastroExistente: false,
      validacao: {},
      mensagemValidacao: {
        aviso:
          "Para uma melhor abordagem do time de saúde verifique suas informações de contato:",
        email: "Informe o seu melhor e-mail",
        numero_celular: "Informe o seu melhor número de telefone de contato.",
      },
      pessoa: { ...valorInicialPessoa },
      listaEstadoCivil: {
        masculino: [
          { nome: "Não informar", id: 0 },
          { nome: "Casado", id: 1, ordem: 2 },
          { nome: "Solteiro", id: 5 },
          { nome: "Separado", id: 2 },
          { nome: "Divorciado", id: 3 },
          { nome: "Viúvo", id: 4 },
        ],
        feminino: [
          { nome: "Não informar", id: 0 },
          { nome: "Casada", id: 1 },
          { nome: "Solteira", id: 5 },
          { nome: "Separada", id: 2 },
          { nome: "Divorciada", id: 3 },
          { nome: "Viúva", id: 4 },
        ],
        outros: [
          { nome: "Não informar", id: 0 },
          { nome: "Casado(a)", id: 1 },
          { nome: "Solteiro(a)", id: 5 },
          { nome: "Separado(a)", id: 2 },
          { nome: "Divorciado(a)", id: 3 },
          { nome: "Viúvo(a)", id: 4 },
        ],
      },
    };
  },
};
</script>

<style scoped>
.form-group {
  margin-top: 1.5vh;
}
.form-group button {
  margin-left: 1.5vh;
}
.hasSuccess {
  color: green;
}
.hasError input {
  border: 1px solid green;
  color: green;
}
.hasError {
  color: red;
}
.hasError input {
  border: 1px solid red;
  color: red;
}

.form-group i, .row i {
  color: red;
  
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/View/CadastroPessoaPage.vue